module.exports = __webpack_public_path__ + "static/media/orders_-LrNP9EMennUvGFbSHA2.8efcc1cd.pdf";